export * from './admin.service';
import { AdminService } from './admin.service';
export * from './customer.service';
import { CustomerService } from './customer.service';
export * from './roles.service';
import { RolesService } from './roles.service';
export const APIS = [AdminService, CustomerService, RolesService];
